var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H31.9956C40.8322 0 47.9956 7.16344 47.9956 16V31.9956C47.9956 40.8322 40.8322 47.9956 31.9956 47.9956H16C7.16344 47.9956 0 40.8322 0 31.9956V16Z",
    fill: "#2F91F8",
    fillOpacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9941 20.9982C14.7897 20.9982 15.5527 21.3142 16.1153 21.8768C16.6778 22.4393 16.9939 23.2023 16.9939 23.9979C16.9939 24.7935 16.6778 25.5565 16.1153 26.119C15.5527 26.6816 14.7897 26.9976 13.9941 26.9976V28.9974C13.9941 29.5278 14.2048 30.0365 14.5799 30.4115C14.9549 30.7866 15.4636 30.9973 15.994 30.9973H31.9925C32.5229 30.9973 33.0315 30.7866 33.4066 30.4115C33.7816 30.0365 33.9923 29.5278 33.9923 28.9974V26.9976C33.1967 26.9976 32.4337 26.6816 31.8712 26.119C31.3086 25.5565 30.9926 24.7935 30.9926 23.9979C30.9926 23.2023 31.3086 22.4393 31.8712 21.8768C32.4337 21.3142 33.1967 20.9982 33.9923 20.9982V18.9984C33.9923 18.468 33.7816 17.9593 33.4066 17.5843C33.0315 17.2092 32.5229 16.9985 31.9925 16.9985H15.994C15.4636 16.9985 14.9549 17.2092 14.5799 17.5843C14.2048 17.9593 13.9941 18.468 13.9941 18.9984V20.9982Z",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9932 16.9985V18.9985",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9932 28.9976V30.9976",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9932 22.998V24.998",
    stroke: "#2F91F8",
    strokeWidth: 1.99982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticon02);
export default __webpack_public_path__ + "static/media/staticon02.b41dd2f16c2d615d48dd87570e6670ee.svg";
export { ForwardRef as ReactComponent };